import React from 'react';
import { ScrollView, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Toggle from '../../../../components/Toggle';
import Header from '../../../../navigation/Header';
import useCommunitySettings from '../../../../hooks/useCommunitySettings';


function SwitchCard({ title, description, value, onValueChange, disabled }) {
  return (
    <View style={tw`bg-white rounded-2xl border border-gray-200 px-4 py-4 mb-3`}>
      <View style={tw`row items-center justify-between mb-2`}>
        <Text style={tw`text-secondary font-600 text-base flex-1 mr-3`}>{title}</Text>
        <Toggle value={value} onValueChange={onValueChange} disabled={disabled} />
      </View>
      <Text style={tw`text-gray-500 text-sm`}>{description}</Text>
    </View>
  )
}


export default function GastosSettingsScreen() {
  const { updateSettings, getSettingValue, isUpdating } = useCommunitySettings()

  return (
    <View style={tw`flex-1 bg-[#F3F2F3]`}>
      <Header showBackButton title="Gastos" style="bg-transparent" />

      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`px-4 pt-4 pb-10`}>
        <SwitchCard
          title="Mostrar gastos a residentes"
          description="Como ejercicio de transparencia, puedes mostrar los gastos y balances a tus residentes para que sepan en qué se gasta el dinero que aportan a la comunidad."
          value={getSettingValue('show_expenses_to_residents', false)}
          onValueChange={(value) => updateSettings('show_expenses_to_residents', value)}
          disabled={isUpdating}
        />
      </ScrollView>
    </View>
  );
}
